import { createTheme, ThemeProvider } from '@mui/material/styles'

export const theme = createTheme({
    palette: {
        primary: {
            main: "#650000",
        },
    },
    components: {
        MuiButton: {
            variants: [
                {
                    props: { variant: "iconAction" },
                    style: {
                        flex: 1,
                        minHeight: 40,
                        borderRadius: 12,
                    }
                },
                {
                    props: { variant: "downloadAction" },
                    style: {
                        borderRadius: 16,
                        fontWeight: 500,
                        color: "inherit",
                        paddingTop: 8,
                        paddingBottom: 8,
                        "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                            color: "inherit"
                        }
                    }
                }
            ]
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: ({ theme }) => ({
                    background: theme.palette.grey[800],
                    color: theme.palette.common.white,
                    minWidth: "auto",
                    justifyContent: "center"
                })
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 700
                }
            }
        }
    }
})

export default function Theme({ children }) {
    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    )
}
